export default "__VITE_ASSET__D8qhZyk5__"